import { Item, TermFragment } from "../interfaces";

/*
 * recursively splits provided **text** into fragments by highlighting the **term**
 * @example
 *
 * // 1st call (by consumer)
 * splitIntoFragments("all cats and dogs", "cat")
 * // 2nd call (by recursion)
 * splitIntoFragments("s and dogs", "cat", [
 *   { text: "all ", isHighlighted: false },
 *   { text: "cat", isHighlighted: true },
 * ])
 * // 3rd call (by recursion)
 * splitIntoFragments("", "cat", [
 *   { text: "all ", isHighlighted: false },
 *   { text: "cat", isHighlighted: true },
 *   { text: "s and dogs", isHighlighted: false },
 * ])
 *
 * returns [
 *   { text: "all ", isHighlighted: false },
 *   { text: "cat", isHighlighted: true },
 *   { text: "s and dogs", isHighlighted: false },
 * ]
 */
const splitIntoFragments = (
  text: string,
  term: string,
  result: TermFragment[] = [],
): TermFragment[] => {
  if (text.length === 0) {
    return result;
  }

  const index = text.toLowerCase().indexOf(term.toLowerCase());

  if (index === -1) {
    return splitIntoFragments("", term, [
      ...result,
      { text, isHighlighted: false },
    ]);
  }

  const fragments = [
    { text: text.slice(0, index), isHighlighted: false },
    { text: text.slice(index, index + term.length), isHighlighted: true },
  ];

  return splitIntoFragments(text.slice(index + term.length), term, [
    ...result,
    ...fragments,
  ]);
};

export const getOrCreateFragments = (item: Item, term: string) => {
  if (
    item.fragments &&
    item.fragments.every(
      (fragment) => "isHighlighted" in fragment && "text" in fragment,
    )
  ) {
    return item.fragments;
  }

  return splitIntoFragments(item.term, term);
};
